// extracted by mini-css-extract-plugin
export default {"eighthsection":"Eighth_eighthsection__ptzh9","title":"Eighth_title__KJT8X","papers":"Eighth_papers__MqiDB","holder":"Eighth_holder__BU7R4","typing":"Eighth_typing__46FUD"};